import store from 'store'
import actions from './actions'
import { factoryReducer } from '../factory'
import packageJson from '../../../package.json'

const STORED_SETTINGS = (storedSettings) => {
  const settings = {}
  Object.keys(storedSettings).forEach((key) => {
    const item = store.get(`app.settings.${key}`)
    settings[key] = typeof item !== 'undefined' ? item : storedSettings[key]
  })
  return settings
}

const initialState = {
  ...STORED_SETTINGS({
    isMobileView: false,
    isMobileMenuOpen: false,
    isLightTheme: true,
    isCalendarEnabled: true,
    isSettingsOpen: false,
    isMenuTop: false,
    isMenuCollapsed: false,
    isBorderless: true,
    isSquaredBorders: false,
    isFixedWidth: false,
    isPatientSelected: false,
    isMenuShadow: false,
    isShowDistance: true,
    distanceRange: 1.5,
    locale: 'en-GB',
    portalVersion: packageJson.version,
    isLatestVersion: true,
  }),
}

export default factoryReducer(initialState, actions)
